export default "__VITE_ASSET__D0xgtd9g__"